import { motion } from "framer-motion";
import { Package, Home, Building2, Forklift, Truck, ArrowRight } from "lucide-react";
import { useLang } from "@/i18n";

const ICONS = [Package, Home, Building2, Forklift, Truck];
const LG_SPANS = ["lg:col-span-4", "lg:col-span-4", "lg:col-span-4", "lg:col-span-6", "lg:col-span-6"];
const MD_SPANS = ["md:col-span-3", "md:col-span-3", "md:col-span-6", "md:col-span-3", "md:col-span-3"];

const reveal = {
    initial: { opacity: 0, y: 26 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, amount: 0.15 },
};

export default function Services() {
    const { t } = useLang();
    const c = t.services;

    return (
        <section id="services" className="scroll-mt-24 py-16 sm:py-24">
            <div className="mx-auto max-w-5xl px-4 sm:px-6">
                <motion.div {...reveal} transition={{ duration: 0.6, ease: [0.16, 1, 0.3, 1] }}>
                    <p className="text-xs font-bold uppercase tracking-[0.22em] text-brand">{c.eyebrow}</p>
                    <h2 className="font-display mt-2 text-3xl font-bold tracking-tight text-ink sm:text-4xl">
                        {c.title}
                    </h2>
                    <p className="mt-2 max-w-xl text-slate-600">{c.sub}</p>
                </motion.div>

                <div className="mt-10 grid grid-cols-1 gap-5 md:grid-cols-6 lg:grid-cols-12">
                    {c.items.map((s, i) => {
                        const Icon = ICONS[i];
                        return (
                            <motion.article
                                key={i}
                                {...reveal}
                                transition={{ duration: 0.6, delay: 0.06 * i, ease: [0.16, 1, 0.3, 1] }}
                                data-testid={`service-card-${i + 1}`}
                                className={`group flex h-full flex-col rounded-3xl border border-emerald-900/10 bg-white p-5 shadow-sm transition-all hover:-translate-y-1 hover:shadow-xl hover:shadow-emerald-900/10 sm:p-6 ${MD_SPANS[i]} ${LG_SPANS[i]}`}
                            >
                                <div className="flex items-center justify-between">
                                    <span className="flex h-11 w-11 items-center justify-center rounded-2xl bg-brand-soft text-brand transition-colors group-hover:bg-brand group-hover:text-white">
                                        <Icon className="h-5 w-5" />
                                    </span>
                                    <span className="font-display text-sm font-bold text-gold">
                                        {String(i + 1).padStart(2, "0")}
                                    </span>
                                </div>
                                <h3 className="font-display mt-4 text-lg font-bold text-ink sm:text-xl">{s.t}</h3>
                                <p className="mt-1.5 flex-1 text-sm leading-relaxed text-slate-600">{s.d}</p>
                            </motion.article>
                        );
                    })}
                </div>

                <motion.a
                    {...reveal}
                    transition={{ duration: 0.6, delay: 0.1 }}
                    href="#book"
                    className="mt-8 inline-flex items-center gap-2 font-semibold text-brand transition-colors hover:text-brand-dark"
                    data-testid="services-book-link"
                >
                    {t.about.more}
                    <ArrowRight className="h-4 w-4 rtl:rotate-180" />
                </motion.a>
            </div>
        </section>
    );
}
